<custom-modal
  modalClass="filing-restricted-modal"
  [open]="isOpen$ | async"
  [header]="'LABELS.FILINGS_RESTRICTED_MODAL.TITLE'"
  [isListenClose]="true"
  (closeClick)="onOpenChange(false)"
  (openChange)="onOpenChange($event)"
>
  <div class="filing-restricted-modal__text">
    {{ "LABELS.FILINGS_RESTRICTED_MODAL.TEXT" | translate }}
  </div>
</custom-modal>
